import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // errorInterceptor primero en la REQUEST = último en ver la RESPUESTA/ERROR (los
    // interceptors la recorren en orden inverso) — así authInterceptor recibe el
    // HttpErrorResponse crudo para poder intentar el refresh antes de que errorInterceptor lo
    // normalice a NormalizedApiError (ver comentario en auth.interceptor.ts).
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor, loadingInterceptor])),
    // Restaura la sesión desde la cookie httpOnly `vendia_refresh` ANTES de que la app
    // renderice — sin esto, un F5 en una ruta protegida con una cookie de refresh válida
    // igual mandaría al login por una fracción de segundo (o de plano no restauraría nada).
    provideAppInitializer(() => inject(AuthService).restoreSession()),
  ]
};
